<div class="banner d-lg-flex d-none">
  <div class="container">
    <h1>{{ 'games.page.arcade.title' | translate }}</h1>
  </div>
</div>

<div class="d-lg-none d-block">
  <fgb-barcode></fgb-barcode>
</div>

<div class="container mt-3">
  <div class="arcade-grid d-lg-flex mb-4">
    <div class="arcade-tile" (click)="launchGame(matchEmAllURL)">
      <img src="assets/images/games/arcade/match-em-all.jpg" />
    </div>

    <div class="arcade-tile" (click)="launchGame(shuffleConeURL)">
      <img src="assets/images/games/arcade/shuffle-cone.jpg" />
    </div>
  </div>
  <div class="arcade-grid d-lg-flex mb-4">
    <div class="arcade-tile" (click)="launchGame(flappyGullyURL)">
      <img src="assets/images/games/arcade/flappy-gully.jpg" />
    </div>

    <div class="arcade-tile" (click)="launchGame(mitomaMagicURL)">
      <img src="assets/images/games/arcade/mitoma-magic.jpg" />
    </div>
  </div>

  <div class="arcade-grid d-lg-flex">
    <div class="arcade-tile" (click)="launchGame(snakeURL)">
      <img src="assets/images/games/arcade/snake.jpg" />
    </div>
  </div>
</div>
